import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-google',
    components: {
    },
})

export default class SSOGoogle extends Vue {

    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        allowedDomains: {
            name: 'Allowed domains',
            field: 'b-form-input',
            modelKey: 'allowedDomains',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        clientID: {
            name: 'Client ID',
            field: 'b-form-input',
            modelKey: 'clientID',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        clientSecret: {
            name: 'Client Secret',
            field: 'b-form-input',
            modelKey: 'clientSecret',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
    };
}
